import { render, staticRenderFns } from "./summary-tab.vue?vue&type=template&id=287816d5&scoped=true"
import script from "./summary-tab.vue?vue&type=script&lang=js"
export * from "./summary-tab.vue?vue&type=script&lang=js"
import style0 from "./summary-tab.vue?vue&type=style&index=0&id=287816d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287816d5",
  null
  
)

export default component.exports